import LessonSummary from './component.jsx'
export default LessonSummary
